import { Component, HostBinding, HostListener, OnInit, ViewContainerRef } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from "app/admin/shared/services/config/config.service";
import { PreloaderService } from "app/admin/shared/services/preloader/preloader.service";
import { SpinnerService } from "app/admin/shared/services/spinner/spinner.service";
import { filter, map, mergeMap } from 'rxjs/operators';
declare var $: any;

@Component({
    selector: "app-root",
    template: "<router-outlet></router-outlet>",
    standalone: false
})

export class AppComponent implements OnInit
{
	//App Left Sidebar Menu Open/Close Desktop
	@HostBinding("class.app_sidebar-menu-collapsed")
	get isApp_SidebarLeftCollapsed()
	{
		return this.config.appLayout.isApp_SidebarLeftCollapsed;
	}
	//Left Menu Sidebar Open/Close Tablet & Mobile
	@HostBinding("class.app_sidebar-left-open")
	get isApp_MobileSidebarLeftOpen()
	{
		return this.config.appLayout.isApp_MobileSidebarLeftOpen;
	}
	//App Right Sidebar Open/Close
	@HostBinding("class.sidebar-overlay-open")
	get isApp_SidebarRightOpen()
	{
		return this.config.appLayout.isApp_SidebarRightOpen;
	}
	//The constructor is called first time before the ngOnInit()
	//The constructor should only be used to initialize class members but shouldn't do actual "work".
	//So you should use constructor() to setup Dependency Injection and not much else.
	constructor(
		public config: ConfigService,
		private viewContainerRef: ViewContainerRef,
		private spinner: SpinnerService,
		private titleService: Title,
		private meta: Meta,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private translateService: TranslateService
	)
	{
		// this language will be used as a fallback when a translation isn't found in the current language
		translateService.setDefaultLang('it');

		// get user lang from localstorage
		let _userLanguage = localStorage.getItem('user_lang') || 'it';

		// the lang to use, if the lang isn't available, it will use the current loader to get them
		translateService.use(_userLanguage);
	}

	public setTitle(newTitle: string)
	{
		this.titleService.setTitle(newTitle);
	}

	//called after the constructor and called  after the first ngOnChanges()
	//ngOnInit() is better place to "start" - it's where/when components' bindings are resolved.
	ngOnInit()
	{
		this.router.events
			.pipe
			(
				filter((event) => event instanceof NavigationEnd),
				map(() => this.activatedRoute),
				map((route) =>
				{
					while (route.firstChild) route = route.firstChild;
					return route;
				}),
				filter((route) => route.outlet === 'primary'),
				mergeMap((route) => route.data)
			)
			.subscribe((event) =>
			{
				if (this.router.url.startsWith('/web'))
				{
					this.titleService.setTitle(this.translateService.instant(event['title']))
				}
				else
				{
					if (event['title'])
						this.titleService.setTitle(this.translateService.instant(event['title']) + ' - Richiesta di cessione del credito')
					else
						this.titleService.setTitle('Richiesta di cessione del credito')
				}
			});

		$(document).on("click", '[href="#"]', e => e.preventDefault());

		this.router.events.subscribe((evt) =>
		{
			if (!(evt instanceof NavigationEnd))
			{
				return;
			}
			$("body,html").scrollTop(0, 0);
		});
	}

	//check if menu should reset on resize
	@HostListener("window:resize")
	public onWindowResize(): void
	{
		if (this._shouldMenuReset())
		{
			this.config.appLayout.isApp_SidebarLeftCollapsed = false;
		}
	}

	private _shouldMenuReset(): boolean
	{
		return window.innerWidth <= this.config.breakpoint.desktopLG;
	}

	public ngAfterViewInit(): void
	{
		PreloaderService.load().then(values =>
		{
			this.spinner.hide();
		});
	}
}
